angular.module('app.directives').directive('userPreview', ($templateCache, $interpolate, $translate) => {
    const id = 'preview_user_modal';
    const wrapper = $templateCache.get('/directives/preview/user_preview_wrapper.html');
    const template = $templateCache.get('/directives/preview/user_preview_template.html');
    const interpolated = $interpolate(template)();
    const compiled = _.template(interpolated);

    angular.element('body').append(wrapper);

    return {
        restrict: 'EA',
        scope: {},
        bindToController: {
            user: '<',
            iconClass: '@',
        },
        templateUrl: '/directives/preview/user_preview_link.html',
        controllerAs: 'userPreview',
        controller() {
            const vm = this;

            vm.id = id;
            vm.previewUser = () => {
                const html = compiled({
                    user: vm.user || '',
                });
                document.getElementById(id).innerHTML = html;
                document.getElementById('user-status').innerText = $translate.instant(document.getElementById('user-status').innerText);
            };
        },
    };
});
